
import { TEXT_SECTION_METADATA } from './text-section.metadata';
import { TextSection } from './text-section.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class TextSectionEntityDecoratorBase extends GenericEntityDecorator<TextSection, string> {
  constructor() {
    super(TEXT_SECTION_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): string {
    if (params == null || params.id == null) {
      return null;
    }
    return params.id;
  }
  toKeyUrlPathSegments(key: string): string {
    if (key == null) {
      return null;
    }
    return key;
  }
  toKeyRouteSegments(item: TextSection): any[] {
    const key: string = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




